import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Stepper from '@material-ui/core/Stepper';
import { withStyles } from '@material-ui/core/styles';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import PropTypes from 'prop-types';
import React from 'react';
import CancelButton from './CancelButton';
import CreateButton from './CreateButton';
import CustomConnector from './CustomConnector';
import CustomStep from './CustomStep';
import PrimaryButton from './PrimaryButton';
import SecondaryButton from './SecondaryButton';
import { globalStyles } from './style/gstheme';

const styles = theme => {
    return Object.assign({
        error: {
            color: theme.palette.error.main,
            marginTop: 20,
            marginBottom: 20
        },
        content: {
            overflowX: 'hidden',
            overflowY: 'auto',
            height: 'calc(100% - 100px)',
            padding: '0px 20px 20px 20px'
        }
    }, globalStyles);
};

class BasicDialogStepper extends React.Component {

    state = {
        activeStep: 0,
        open: false
    };

    handleClickOpen = () => this.setState({ activeStep: 0, open: true });

    exitStepper = () => {
        this.handleReset();
        this.props.onExitStepper();
    };

    handleNext = () => {
        const { activeStep } = this.state;
        if (activeStep === this.props.steps.length - 1) {
            this.handleReset();
            this.props.onComplete();
        }
        else {
            this.setState({ activeStep: activeStep + 1 });
        }
    };

    handleBack = () => this.setState(state => ({ activeStep: state.activeStep - 1 }));

    handleReset = () => this.setState({ open: false });

    render() {
        const { classes, getStepContent, steps, title, maxWidth, canContinue, height, width } = this.props;
        const { activeStep } = this.state;
        const isFinished = this.props.isComplete();

        return (
            <React.Fragment>
                <CreateButton dataTest="initiate-stepper" onClick={this.handleClickOpen} label={title} />
                <Dialog data-test="stepper" maxWidth={maxWidth} open={this.state.open} onClose={this.exitStepper} aria-labelledby="dialog-title">
                    <DialogTitle disableTypography className={classes.mainHeading} id="dialog-title">{title}</DialogTitle>
                    <DialogContent style={{ height, width, maxWidth: '100%', padding: '0px' }}>
                        <Stepper
                            activeStep={activeStep}
                            connector={<CustomConnector />}
                            style={{ paddingTop: '0px', justifyContent: 'space-between' }}>
                            {steps.map((label, index) => {
                                return (
                                    <CustomStep key={label} activeStep={activeStep} index={index} label={label} />
                                );
                            })}
                        </Stepper>
                        <div data-test="stepper-content" className={classes.content}>
                            {getStepContent(activeStep)}
                        </div>
                    </DialogContent>
                    <DialogActions className={classes.dialogActions} style={{ justifyContent: 'space-between' }}>
                        <CancelButton onClick={this.exitStepper} />
                        <div>
                            <span style={{ marginRight: '12px' }}>
                                {activeStep > 0 &&
                                    <SecondaryButton
                                        onClick={this.handleBack}
                                        className={classes.button}
                                        startIcon={<ArrowBackIcon />}>Previous</SecondaryButton>
                                }
                            </span>
                            <span>
                                {activeStep === steps.length - 1 && canContinue &&
                                    <PrimaryButton disabled={!isFinished} onClick={this.handleNext}>Finish</PrimaryButton>
                                }
                                {activeStep < steps.length - 1 &&
                                    <PrimaryButton disabled={!canContinue} onClick={this.handleNext} endIcon={<ArrowForwardIcon />}>Next</PrimaryButton>
                                }
                            </span>
                        </div>
                    </DialogActions>
                </Dialog>
            </React.Fragment>
        );
    }
}

BasicDialogStepper.defaultProps = {
    maxWidth: "xl",
    canContinue: true,
    height: '200px',
    width: '800px'
};

BasicDialogStepper.propTypes = {
    canContinue: PropTypes.bool,
    steps: PropTypes.arrayOf(PropTypes.string).isRequired,
    getStepContent: PropTypes.func.isRequired,
    isComplete: PropTypes.func.isRequired,
    onExitStepper: PropTypes.func.isRequired,
    height: PropTypes.string,
    maxWidth: PropTypes.string,
    width: PropTypes.string,
    onComplete: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired,
    classes: PropTypes.object
};

export default withStyles(styles)(BasicDialogStepper);